import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function DocsValidityIcon({ className }: IconProps) {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3914)">
        <path
          d="M61.7523 70V3.17221C61.7523 1.48036 60.2719 0 58.5801 0H3.17221C1.48036 0 0 1.48036 0 3.17221V61.3293C0 65.9819 3.80665 69.7885 8.45922 69.7885H61.7523V70Z"
          fill="#EAEEF9"
        />
        <path
          d="M7.18989 30.0302H4.22917C3.80621 30.0302 3.59473 30.2417 3.59473 30.6647V37.6435C3.59473 37.855 3.80621 38.0665 4.22917 38.0665H7.18989C7.61285 38.0665 7.82433 37.855 7.82433 37.432V30.4532C7.82433 30.2417 7.40137 30.0302 7.18989 30.0302Z"
          fill="white"
        />
        <path
          d="M13.1122 24.9547H10.363C9.94 24.9547 9.72852 25.1662 9.72852 25.5891V37.6435C9.72852 38.0665 9.94 38.2779 10.363 38.2779H13.3237C13.7466 38.2779 13.9581 38.0665 13.9581 37.6435V25.5891C13.7466 25.1662 13.5352 24.9547 13.1122 24.9547Z"
          fill="white"
        />
        <path
          d="M19.2446 16.9184H16.2839C15.8609 16.9184 15.6494 17.3414 15.6494 17.5529V37.432C15.6494 37.855 15.8609 38.0665 16.2839 38.0665H19.2446C19.6675 38.0665 19.879 37.855 19.879 37.432V17.5529C19.879 17.3414 19.4561 16.9184 19.2446 16.9184Z"
          fill="white"
        />
        <path
          d="M25.1665 20.5136H22.2057C21.7828 20.5136 21.5713 20.7251 21.5713 21.148V37.6435C21.5713 38.0665 21.7828 38.2779 22.2057 38.2779H25.1665C25.5894 38.2779 25.8009 38.0665 25.8009 37.6435V21.148C25.8009 20.7251 25.5894 20.5136 25.1665 20.5136Z"
          fill="white"
        />
        <path
          d="M31.2993 13.3233H28.3385C27.9156 13.3233 27.7041 13.5347 27.7041 13.9577V37.432C27.7041 37.855 27.9156 38.0665 28.3385 38.0665H31.2993C31.7222 38.0665 31.9337 37.855 31.9337 37.432V13.9577C31.9337 13.5347 31.5107 13.3233 31.2993 13.3233Z"
          fill="white"
        />
        <path
          d="M36.3741 44.8338H27.2805C26.8575 44.8338 26.4346 44.4109 26.4346 43.7764C26.4346 43.142 26.8575 42.9305 27.2805 42.9305H36.3741C36.7971 42.9305 37.4316 43.3535 37.4316 43.7764C37.4316 44.1994 37.0086 44.8338 36.3741 44.8338Z"
          fill="white"
        />
        <path
          d="M22.4173 44.8338H20.3025C19.8796 44.8338 19.2451 44.4109 19.2451 43.7764C19.2451 43.142 19.6681 42.9305 20.3025 42.9305H22.4173C22.8403 42.9305 23.2632 43.3535 23.2632 43.7764C23.2632 44.1994 23.0518 44.8338 22.4173 44.8338Z"
          fill="white"
        />
        <path
          d="M36.3741 51.1782H27.2805C26.8575 51.1782 26.4346 50.7553 26.4346 50.1208C26.4346 49.4864 26.8575 49.0634 27.2805 49.0634H36.3741C36.7971 49.0634 37.4316 49.4864 37.4316 50.1208C37.4316 50.7553 37.0086 51.1782 36.3741 51.1782Z"
          fill="white"
        />
        <path
          d="M22.4173 51.1782H20.3025C19.8796 51.1782 19.2451 50.7553 19.2451 50.1208C19.2451 49.4864 19.6681 49.0634 20.3025 49.0634H22.4173C22.8403 49.0634 23.2632 49.4864 23.2632 50.1208C23.2632 50.7553 23.0518 51.1782 22.4173 51.1782Z"
          fill="white"
        />
        <path
          d="M54.562 57.5227H27.281C26.8581 57.5227 26.2236 57.0997 26.2236 56.4653C26.2236 55.8308 26.6466 55.6193 27.281 55.6193H54.562C54.985 55.6193 55.6194 56.0423 55.6194 56.4653C55.6194 56.8882 55.1964 57.5227 54.562 57.5227Z"
          fill="white"
        />
        <path
          d="M22.4173 57.5227H20.3025C19.8796 57.5227 19.2451 57.0997 19.2451 56.4653C19.2451 55.8308 19.6681 55.6193 20.3025 55.6193H22.4173C22.8403 55.6193 23.2632 56.0423 23.2632 56.4653C23.2632 56.8882 23.0518 57.5227 22.4173 57.5227Z"
          fill="white"
        />
        <path
          d="M46.1028 63.8671H27.281C26.8581 63.8671 26.2236 63.4441 26.2236 62.8097C26.2236 62.1752 26.6466 61.7523 27.281 61.7523H46.1028C46.5257 61.7523 47.1602 62.1752 47.1602 62.8097C47.1602 63.4441 46.5257 63.8671 46.1028 63.8671Z"
          fill="#B0B9CF"
        />
        <path
          d="M22.4173 63.8671H20.3025C19.8796 63.8671 19.2451 63.4441 19.2451 62.8097C19.2451 62.1752 19.6681 61.7523 20.3025 61.7523H22.4173C22.8403 61.7523 23.2632 62.1752 23.2632 62.8097C23.2632 63.4441 23.0518 63.8671 22.4173 63.8671Z"
          fill="#B0B9CF"
        />
        <path
          d="M8.6709 70C12.689 70 16.0727 67.0393 16.7072 63.0211C16.7072 62.3867 17.3416 61.9637 17.976 61.9637H68.5198C69.3658 61.9637 70.0002 62.5982 69.7887 63.4441C69.1543 67.2508 65.7706 70 61.7525 70H8.6709Z"
          fill="#00C4B3"
        />
        <path
          d="M59.2141 26.2236C59.2141 23.0514 57.9452 20.0906 55.8304 17.9758C53.5042 15.6495 50.5434 14.5921 47.3712 14.5921C44.199 14.5921 41.2383 15.861 38.912 17.9758C36.5857 20.3021 35.5283 23.2628 35.5283 26.435C35.5283 29.6073 36.7972 32.568 38.912 34.8943C41.0268 37.0091 43.9875 38.2779 47.1597 38.2779H47.3712C50.5434 38.2779 53.5042 37.0091 55.8304 34.8943L56.2534 34.4713L54.3501 32.568L53.9271 32.9909C52.2353 34.6828 49.909 35.7402 47.3712 35.7402C44.8335 35.7402 42.5072 34.6828 40.8153 32.9909C39.1235 31.2991 38.0661 28.9728 38.0661 26.435C38.0661 23.8973 39.1235 21.571 40.8153 19.8792C42.5072 18.1873 44.8335 17.1299 47.3712 17.1299C49.909 17.1299 52.2353 18.1873 53.9271 19.8792C55.4075 21.3595 56.2534 23.2628 56.4649 25.1662H54.5616H54.3501C54.1386 23.6858 53.2927 22.4169 52.2353 21.148C50.7549 19.6677 49.0631 19.0332 46.9483 19.0332C45.0449 19.0332 43.1416 19.8792 41.6613 21.148C40.1809 22.6284 39.5465 24.3202 39.5465 26.435C39.5465 28.5499 40.3924 30.2417 41.6613 31.7221C42.9301 32.9909 44.8335 33.8369 46.7368 33.8369H46.9483C48.8516 33.8369 50.7549 32.9909 52.2353 31.7221L52.6582 31.2991L50.7549 29.3958V29.8187C49.909 30.6647 48.6401 31.2991 47.3712 31.2991C46.1023 31.2991 44.8335 30.8761 43.9875 29.8187C43.3531 29.1843 42.9301 28.5499 42.7187 27.7039H46.1023H47.3712H52.2353H54.773H59.2141V26.2236ZM47.3712 25.1662H46.1023H42.7187C42.9301 24.3202 43.3531 23.6858 43.9875 23.0514C44.8335 22.2054 46.1023 21.571 47.3712 21.571C48.6401 21.571 49.909 21.994 50.7549 23.0514C51.3893 23.6858 51.8123 24.3202 52.0238 25.1662H47.3712Z"
          fill="#00416B"
        />
        <path
          d="M66.828 25.8006C66.828 34.8943 59.4262 42.5076 50.121 42.5076C41.0274 42.5076 33.4141 35.1057 33.4141 25.8006C33.4141 16.707 40.8159 9.09366 50.121 9.09366C59.2147 9.30514 66.828 16.707 66.828 25.8006Z"
          fill="#00416B"
        />
        <path
          d="M64.5016 25.8006C64.5016 33.8369 57.9457 40.1813 50.1209 40.1813C42.0846 40.1813 35.7402 33.6254 35.7402 25.8006C35.7402 17.7643 42.2961 11.4199 50.1209 11.4199C58.1572 11.4199 64.5016 17.9758 64.5016 25.8006Z"
          fill="#EAEEF9"
        />
        <path
          d="M54.1388 16.4955L48.0059 24.9547L52.4469 27.0695L54.9847 16.9184C55.1962 16.284 54.3503 16.0725 54.1388 16.4955Z"
          fill="#00C4B3"
        />
        <path
          d="M42.7187 22.6284L48.8516 27.0695L50.332 23.8973L43.1417 21.994C42.7187 21.994 42.5072 22.4169 42.7187 22.6284Z"
          fill="#00C4B3"
        />
        <path
          d="M53.2927 25.8006C53.2927 27.4925 51.8123 28.9728 50.1204 28.9728C48.4286 28.9728 46.9482 27.4925 46.9482 25.8006C46.9482 24.1088 48.4286 22.6284 50.1204 22.6284C51.8123 22.8399 53.2927 24.1088 53.2927 25.8006Z"
          fill="#FBFCFE"
        />
        <path
          d="M51.6013 25.8006C51.6013 26.6465 50.9669 27.281 50.121 27.281C49.2751 27.281 48.6406 26.6465 48.6406 25.8006C48.6406 24.9547 49.2751 24.3202 50.121 24.3202C50.9669 24.3202 51.6013 24.9547 51.6013 25.8006Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3914">
          <rect width="69.7885" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
